import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'report-permission-control',
  props: {
    ids: { default: () => [] },
    names: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function select(choiceInput: boolean): void {
  axios
    .patch("/api/reportpermissions/", {
      allow: choiceInput,
      ids: props.ids,
    })
    .then(() => {
      emit("input", choiceInput);
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      "data-test": "report-control-yes",
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (select(true))),
      type: "button"
    }, " Yes"),
    _createTextVNode("  "),
    _createElementVNode("button", {
      "data-test": "report-control-no",
      class: "btn btn-default",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (select(false))),
      type: "button"
    }, " No ")
  ]))
}
}

})